import { IconeBarco } from "@/shared/components/icone-barco";
import { FINANCEIRO_NO_VALUE } from "../../financeiro-obras.constants";
import styles from "./financeiro-condicao.module.scss";
import type { FinanceiroCondicaoViewModel } from "./types-financeiro-condicao";

/**
 * Condição da parada na célula da Lista: identificação visual (ícone do navio) + texto, sem condição = "-"; valor
 * desconhecido mostra só o texto. No Card, o ícone e a tooltip são do `ObraCard` do shared.
 */
export function FinanceiroCondicaoView({
  isEmpty,
  label,
  seco,
  known,
  testId,
}: FinanceiroCondicaoViewModel) {
  if (isEmpty) return <>{FINANCEIRO_NO_VALUE}</>;

  return (
    <span className={styles.condicao} data-seco={seco || undefined} data-testid={testId}>
      {known ? (
        <IconeBarco condicao={seco ? "seco" : "molhado"} className={styles.icon} aria-hidden />
      ) : null}
      <span>{label}</span>
    </span>
  );
}
